import {
  ADD_CREDIT,
  ADD_CREDIT_FAILURE,
  CLEAR_CREDIT_ERROR,
  GET_CREDIT_FAILURE,
  GET_CREDIT_REQUEST,
  GET_CREDIT_SUCCESS,
  WITHDRAW_CREDIT,
  WITHDRAW_CREDIT_FAILURE,
} from "../../constants/CreditSystemConstants";


const CreditState = {
  loading: false,
  creditData: { totalCredits: 0, history: [] },
  error: null,
};

export const creditReducer = (state = CreditState, action) => {
  switch (action.type) {
    case GET_CREDIT_REQUEST:
      return { ...state, loading: true };
    case GET_CREDIT_SUCCESS:
      return { ...state, loading: false, creditData: action.payload, error: null };
    case GET_CREDIT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ADD_CREDIT:
    case WITHDRAW_CREDIT:
      return { ...state, loading: false, creditData: action.payload, error: null };
    case ADD_CREDIT_FAILURE:
    case WITHDRAW_CREDIT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_CREDIT_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};